export const TRAVELER_SELECT_DROPDOWN_TITLE = "Select or add driver";
export const TRAVELER_SELECT_DROPDOWN_DESCRIPTION =
  "Make sure the information you add matches the driver’s license. You can’t change this information after booking.";
